import { useQuery } from "@tanstack/react-query";
import { ChartOfAccountAPI, CostCenterAPI } from "api";

const fetchChartOfAccounts = (costCenterId) => {
  return ChartOfAccountAPI.get({ params: { costCenterId } });
};
export const useFetchChartOfAccounts = (costCenterId) => {
  return useQuery({
    queryKey: ["chart-of-accounts", costCenterId],
    queryFn: () => fetchChartOfAccounts(costCenterId),
    refetchOnWindowFocus: false, // Disable refetching on window focus
  });
};
